import {
  Component,
  ViewEncapsulation,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { TranslatePipe } from '@app/pipes/translate.pipe';
import { GenericButtonWithArrow } from '@components/shared/genericButtonWithArrow/genericButtonWithArrow';
import { NgOptimizedImage } from '@angular/common';
import { Router } from '@angular/router';
import { LocalizationService } from '@services/logic/localization.service';

@Component({
  imports: [NgOptimizedImage, TranslatePipe, GenericButtonWithArrow],
  providers: [TranslatePipe, Router],
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'app-service-provider-value-prop',
  templateUrl: './service-provider-value-prop.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./service-provider-value-prop.component.scss'],
})
export class ServiceProviderValuePropComponent {
  private readonly loc = inject(LocalizationService);
  protected readonly findWorkPath = this.loc.seoRoute('find-work');

  constructor(
    public router: Router,
    public translatePipe: TranslatePipe,
  ) {}
}
